import { useMutation } from '../useMutation'
import { resetPasswordQuery } from './graphql'

type ResetPasswordInput = { _id: string; customPassword?: string }

export type UseResetPasswordResult = {
  executeIt: (args: ResetPasswordInput) => Promise<any>
  loading: boolean
  error: any
}

export const useResetPassword = (): UseResetPasswordResult => {
  const [resetPassword, , { loading, error }] = useMutation({ query: resetPasswordQuery })

  const executeIt = ({ _id, customPassword }: ResetPasswordInput) => {
    return resetPassword({ input: { userId: _id, customPassword } })
  }

  return { executeIt, loading, error }
}
